import ApolloClient from 'apollo-boost';
import { InMemoryCache } from 'apollo-cache-inmemory';

import { trackedFetch } from 'state/spinner/trackedFetch';

import { customAggregateSubtotalsKeysInCache } from './cacheConfig';

const cache = new InMemoryCache({ ...customAggregateSubtotalsKeysInCache });

const client = new ApolloClient({
  uri: '/graphql',
  cache,
  fetch: trackedFetch,
});

export default client;
